<template>

    <div>

        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', 'orders-and-menu') ">

            Back
        </button>
        <button class="options-btn btn-blue" @click=" viewMenu() ">

            <font-awesome-icon icon="eye" size="3x" />
            View Menu
        </button>
        <button class="options-btn btn-blue" @click=" editMenu() ">

            <font-awesome-icon icon="pencil-alt" size="3x" />
            Edit Menu
        </button>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'menu-options',
        methods: {

            viewMenu(){

                this.$router.push( { name: 'order-menu' } );
            },
            editMenu(){

                this.$router.push( { name: 'edit-menu' } );
            }
        },
        components: {

            FontAwesomeIcon
        }
    }

</script>

<style scoped>

</style>